import type { Repository, RepositoryDump } from "./repository";

// Backup envelope. Judgement data only: no settings, so a downloaded file never
// carries an API key.
export const BACKUP_APP = "strad-trust-lens";
export const BACKUP_VERSION = 1;

export interface BackupFile {
  app: string;
  version: number;
  exportedAt: number;
  data: RepositoryDump;
}

export async function buildBackup(
  repo: Repository,
  now: number,
): Promise<BackupFile> {
  return {
    app: BACKUP_APP,
    version: BACKUP_VERSION,
    exportedAt: now,
    data: await repo.exportAll(),
  };
}

// Validate an untrusted file before we let it replace the store.
export function parseBackup(text: string): BackupFile {
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw new Error("That file is not valid JSON.");
  }
  const b = parsed as Partial<BackupFile>;
  const d = b?.data as Partial<RepositoryDump> | undefined;
  if (
    !b ||
    b.app !== BACKUP_APP ||
    !d ||
    !Array.isArray(d.people) ||
    !Array.isArray(d.dimensions) ||
    !Array.isArray(d.tags) ||
    !Array.isArray(d.decisions)
  ) {
    throw new Error("This file is not a Trust Lens backup.");
  }
  // instances, rating history and domains were added later; tolerate older
  // backups by defaulting the arrays that may be absent.
  if (!Array.isArray(d.instances)) d.instances = [];
  if (!Array.isArray(d.ratingEvents)) d.ratingEvents = [];
  if (!Array.isArray(d.topics)) d.topics = [];
  if (!Array.isArray(d.personTopics)) d.personTopics = [];
  return b as BackupFile;
}

export async function restoreBackup(
  repo: Repository,
  file: BackupFile,
): Promise<void> {
  await repo.importAll(file.data);
}
